export class AnalyticsNames {
  static billingHistoryQuery = 'billing-history';
  static patientListQuery = 'patients';
  static submitBasket = 'submit-basket';
  static submitQueueItem = 'submit-queue-item';
  static userList = 'users';
  static materialListQuery = 'materials';
  static pendingCreditApprovalsListQuery = 'credit-approvals';
  static submitCreditRequest = 'credit-request';
  static rejectCreditRequest = 'reject-credit-request';
  static approveCreditRequest = 'approve-credit-request';
  static doctorListQuery = 'doctors';
  static servicesListQuery = 'services';
  static procedureListQuery = 'procedures';
  static packListQuery = 'packs';
  static roomListQuery = 'rooms';
}
